import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import { usePatchProjectmelding } from '../../hooks/usePatchProjectmelding'

export interface Props {
  id: string
  handleClose: () => void
}

export const Afwijzen = ({ id, handleClose }) => {
  const { mutate: patchProjectmelding } = usePatchProjectmelding()

  const handleClickJa = () => {
    patchProjectmelding(
      { id },
      {
        onSuccess: () => {
          handleClose()
        },
      },
    )
  }

  return (
    <Dialog open>
      <DialogTitle>Projectmelding afwijzen</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Wilt u deze projectmelding afwijzen?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClickJa()} color="primary">
          Ja
        </Button>
        <Button onClick={handleClose} color="primary" autoFocus>
          Nee
        </Button>
      </DialogActions>
    </Dialog>
  )
}
